// Dependencies
import React, { createClass, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { IconButton } from 'material-ui';
import getClassNames from 'classnames';
import docCookies from '../../../utils/docCookie';

// Components
import VertDropDown from '../connections-vert-dropdown';
import Icon from '../../tc-ui/icon';
import { Paper, TextField } from 'material-ui';
import Select from 'react-select';


const ConnectionsSearchBar = createClass({

  propTypes: {
    config: PropTypes.object,
    connectionsToolbar: PropTypes.bool,
    search: PropTypes.func,
    filteredCountries: PropTypes.array,
    filterByCountry: PropTypes.func,
    className: PropTypes.string,
    connections: PropTypes.object,
  },

  getInitialState() {
    return {
      open: true,
      input: '',
    };
  },

  onClick() {
    document.getElementById('connectionsSearch').focus();
    this.setState({ open: !this.state.open }, () => {
      if (this.state.open) document.getElementById('connectionsSearch').focus();
      else document.getElementById('connectionsSearch').blur();
    });
  },

  downloadAllContacts() {
    docCookies.setItem('userid', this.props.user.id, undefined, '/', 'tourconnect.com');
    window.location = `${this.props.config.apiUrl}/download_all_contacts`;
  },

  preventTabAndEnter(event) {
    if (event.which === 13 || event.which === 9) {
      event.preventDefault();
    }
  },

  searchContent(value) {
    this.props.search(value);
    this.setState({ input: value });
  },

  clearInput() {
    this.props.search('');
    this.setState({ input: '' });
  },


  countryChanged(selections) {
    const { filteredCountries, filterByCountry } = this.props;
    filterByCountry(filteredCountries.concat(selections.map(selection => selection.value)));
  },

  render() {
    const { connections, filteredCountries } = this.props;
    const classes = getClassNames('connections-search-input', this.props.className, {
      'is-closed': !this.state.open,
    });

    const icon = this.state.open && this.state.input ? (
        <Icon className="tc-icon-close" onClick={this.clearInput} />
      ) : (
        <Icon className="tc-icon-search" onClick={this.onClick} />
      );

    const countriesServed = connections.countries
                              .filter(country => filteredCountries.indexOf(country) === -1)
                              .map(country => ({ value: country, label: country }));

    let filterOptions;
    let downloadIcon;
    let filters;
    let searchbar;

    if (countriesServed) {
      filterOptions = [{
        type: 'nestedmenu',
        isOnNestedMultiselect: true,
        subOptions: [{
          text:
            <Select
              multi
              name={"countriesServed"}
              onChange={this.countryChanged}
              layout={"l-paper-right multi-select"}
              scrollMenuIntoView={false}
              options={countriesServed}
            />,
          leaveMenuOpen: true,
        }],
        text: 'Filter By Country',
        icon: <Icon className="tc-icon-chevron-right" />,
      }];
    }

    if (this.props.connectionsToolbar) {
      downloadIcon = (
        <IconButton
          style={{ top: '-4px' }}
          iconClassName="tc-icon-cloud-download"
          onTouchTap={this.downloadAllContacts}
          tooltip="Download Connections"
        />
      );
      filters = (
        <VertDropDown
          isMultiSelect
          componentClassName="connections-more-options connections-actions"
          label="Filters"
          options={filterOptions}
        />
      );
    } else {
      searchbar = (
        <div>
          <Paper>
            <TextField
              hintText="Search Connections..."
              id="connectionsSearch"
              className={classes}
              onKeyDown={this.preventTabAndEnter}
              onChange={({ target: { value } }) => this.searchContent(value)}
              style={{ width: '97%' }}
              value={this.state.input}
            />
          </Paper>
          {icon}
        </div>
      );
    }

    return (
      <div className={`connections-search-bar ${this.props.className}`}>
        {searchbar}
        {filters}
      </div>
    );
  },
});

export default ConnectionsSearchBar;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-toolbar/connections-search.jsx